import React, { FC } from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { FooterLink } from './FooterLink';
import { FooterSocialLinks } from './FooterSocialLinks';
import { FanaticsCollectLogo } from '../../../Icons/FanaticsCollectLogo';
import { EColor, ETextVariant } from '../../../Theme';
import { maxWidths } from '../../../utilities';
import { useMonolithUrls } from '../../hooks/useMonolithUrls';
import { getFooterSocialLinks } from '../../hooks/useNavItems';

export const FooterCopyright: FC = () => {
  const { privacyPolicyUrl, termsOfUseUrl } = useMonolithUrls();
  const footerSocialLinks = getFooterSocialLinks();

  return (
    <Flex bg={EColor.Neutral0} justify="center" w="100%">
      <Flex
        align="center"
        flexDirection="row"
        flexWrap={{ base: 'wrap', md: 'nowrap' }}
        justify="space-between"
        maxW={maxWidths}
        px={{ base: '30px', sm: '16px' }}
        py="32px"
        rowGap="16px"
        w="100%"
      >
        <Text
          fontFamily="ABC Diatype"
          order={{ base: 2, md: 1 }}
          variant={ETextVariant.XSBold}
          whiteSpace="nowrap"
        >
          ©{' '}
          <FanaticsCollectLogo
            bottom="4px"
            height="16px"
            position="relative"
            width="112px"
          />
          {` ${new Date().getFullYear()}`}
        </Text>

        <Flex
          justify="center"
          order={{ base: 1, md: 2 }}
          w={{ base: '100%', md: 'auto' }}
        >
          <FooterSocialLinks links={footerSocialLinks} />
        </Flex>

        <Flex
          columnGap={{ base: '8px', md: '16px' }}
          order={{ base: 3, md: 3 }}
        >
          <FooterLink
            dense
            data-testid="footer-link-privacy-policy"
            href={privacyPolicyUrl}
            name="Privacy policy"
            textDecoration="underline"
            whiteSpace="nowrap"
          />

          <FooterLink
            dense
            data-testid="footer-link-terms-of-use"
            href={termsOfUseUrl}
            name="Terms of use"
            textDecoration="underline"
            whiteSpace="nowrap"
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
